import { api } from "./api";

// Público
export async function fetchProgramas() {
  const { data } = await api.get("/software/programas");
  return data; // [{id, name, type, status, ...}]
}

// Admin
export async function fetchProgramasAdmin() {
  const { data } = await api.get("/software/admin/programas");
  return data;
}

export async function crearPrograma(payload) {
  const { data } = await api.post("/software/admin/programas", payload);
  return data;
}

export async function actualizarPrograma(id, payload) {
  const { data } = await api.put(`/software/admin/programas/${id}`, payload);
  return data;
}

export async function cambiarEstadoPrograma(id, status) {
  const { data } = await api.patch(`/software/admin/programas/${id}/estado`, { status });
  return data;
}

export async function eliminarPrograma(id) {
  await api.delete(`/software/admin/programas/${id}`);
}

// F4-C · Media de programa: subida de archivo (imagen|video) y set de URL de video.
export async function subirMediaPrograma(id, campo, file, onProgress) {
  const form = new FormData();
  form.append("campo", campo); // "imagen" | "video"
  form.append("file", file);
  const { data } = await api.post(`/software/admin/programas/${id}/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => { if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total)); },
  });
  return data; // programa admin serializado
}

export async function setMediaPrograma(id, body) {
  const { data } = await api.put(`/software/admin/programas/${id}/media`, body);
  return data;
}

// PASO 2B · Instalador por plataforma (windows|android): subir/reemplazar (admin) y eliminar.
export async function subirInstaladorPrograma(id, platform, file, onProgress) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(`/software/admin/programas/${id}/installer/${platform}`, form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => { if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total)); },
  });
  return data;
}

export async function borrarInstaladorPrograma(id, platform) {
  const { data } = await api.delete(`/software/admin/programas/${id}/installer/${platform}`);
  return data;
}

export const ESTADOS_PROGRAMA = ["PROXIMAMENTE", "DISPONIBLE", "BETA", "NO_DISPONIBLE"];
export const TIPOS_PROGRAMA = ["MASTER_PROGRAM", "SPECIALIZED_PROGRAM"];
export const ICONOS_PROGRAMA = [
  "Boxes", "Home", "Route", "Droplet", "Waves", "Building2", "PlugZap",
  "HardHat", "Ruler", "Wrench", "Calculator", "Landmark",
];
